import { render, staticRenderFns } from "./Selected.vue?vue&type=template&id=f1020bb4&scoped=true&"
import script from "./Selected.vue?vue&type=script&lang=js&"
export * from "./Selected.vue?vue&type=script&lang=js&"
import style0 from "./Selected.vue?vue&type=style&index=0&id=f1020bb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1020bb4",
  null
  
)

export default component.exports